import type React from 'react';
import { Navigate } from 'react-router-dom';
import { hasRefreshableSession } from '@/utils';
import { PATH } from '@/router/PATH';
import { LoginView } from './LoginView';
import { useLogin } from './useLogin';

export const Login: React.FC = () => {
    const logic = useLogin();

    // Already have a (refreshable) session: skip the form entirely so /login
    // can't shadow the app. Mirrors the secured-route guard so the two never
    // disagree about whether a user is "in".
    if (hasRefreshableSession()) {
        return <Navigate replace to={PATH.HOME} />;
    }

    return <LoginView {...logic} />;
};
